import { SVGProps } from "react";

export default function MinusIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 13, width = 12, fill = "#292D32", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M3 6.5H9"
        stroke={fill}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
